<template>
  <div :class="$style.sectionIncome">
    <div class="container section">
      <p class="dingbeauty-sub-title fancy-title">Advantage</p>
      <h2 class="dingbeauty-title is-dotted">體驗最前端的預約管理</h2>

      <div class="income-wrapper">
        <div class="wrapper-item-title">
          <p class="title">{{ currentItem.titleName }}</p>
          <div style="color: #4D4D4D;" v-html="currentItem.description"></div>
          <swiper ref="title-swiper" class="title-swiper" :options="titleSwiperOptions" :breakpoints="titleSwiperOptions.breakpoints">
            <swiperSlide v-for="(item, index) in list" :key="index" class="title-swiper-item">
              <div @click="slideTo(index)" @keydown="slideTo(index)" :class="{ isActive: currentIndex === index }">
                <div class="icon-img-wrapper">
                  <img class="icon-img" :src="item.iconImg" alt="" />
                  <img class="icon-bg" src="@assets/dingbeauty-images/basic-plan/advantage/icon_circle.svg" alt="" />
                </div>
                <p class="icon-name">{{ item.titleName }}</p>
              </div>
            </swiperSlide>
          </swiper>
          <img @click="slidePrev" class="left-arrow" src="@assets/dingbeauty-images/basic-plan/advantage/Icon_arrowL.svg" alt="" />
          <img @click="slideNext" class="right-arrow" src="@assets/dingbeauty-images/basic-plan/advantage/Icon_arrowR.svg" alt="" />
        </div>

        <div class="wrapper-item-preview">
          <img @click="slidePrev" class="left-arrow" src="@assets/dingbeauty-images/basic-plan/advantage/Icon_arrowL.svg" alt="" />
          <swiper ref="preview-swiper" class="preview-swiper" :options="previewSwiperOptions">
            <swiperSlide v-for="(item, index) in list" :key="index">
              <img class="preview-swiper-img" :src="item.previewImg" alt="" />
            </swiperSlide>
          </swiper>
          <img @click="slideNext" class="right-arrow" src="@assets/dingbeauty-images/basic-plan/advantage/Icon_arrowR.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
    swiper,
    swiperSlide,
  },

  data() {
    return {
      currentItem: {},
      currentIndex: 0,
      list: [
        {
          titleName: '雲端數位化',
          iconImg: require('@assets/dingbeauty-images/basic-plan/advantage/icon_cloud.svg'),
          previewImg: require('@assets/dingbeauty-images/basic-plan/advantage/img_cloud.png'),
          description: `<p class='description'>讓您的品牌完成數位轉型，節省成本，創造收益！輕鬆實現即時存取、數據分析，並提供更便捷、安全的預約體驗，增強您的市場競爭力。</p>`,
        },
        {
          titleName: '多元式預約',
          iconImg: require('@assets/dingbeauty-images/basic-plan/advantage/icon_devices.svg'),
          previewImg: require('@assets/dingbeauty-images/basic-plan/advantage/img_reservation.png'),
          description: `<p class='description'>愛美訂整合線上線下預約，讓您忙碌時不再錯失商機！不論是透過網站、Google地圖或是LINE，讓您的客人輕鬆上手，只要上網就可以預約！</p>`,
        },
        {
          titleName: '營運與管理',
          iconImg: require('@assets/dingbeauty-images/basic-plan/advantage/icon_manage.svg'),
          previewImg: require('@assets/dingbeauty-images/basic-plan/advantage/img_manage.png'),
          description: `<p class='description'>最細節的營運與管理系統，讓您輕鬆掌握業務狀況！精確記錄預約細節並進行數據化管理，有效提高您的運營效率，讓您聰明管理，輕鬆經營。</p>`,
        },
        {
          titleName: '客戶管理',
          iconImg: require('@assets/dingbeauty-images/basic-plan/advantage/icon_client.svg'),
          previewImg: require('@assets/dingbeauty-images/basic-plan/advantage/img_client.png'),
          description: `<p class='description'>最專業的客戶管理，幫助您的品牌建立強而有力的客戶關係！即時查閱客戶歷史預約、服務記錄與個人偏好，並提供會員分級功能，讓您輕鬆管理，準確瞄準顧客喜好！</p>`,
        },
      ],

      titleSwiperOptions: {
        slidesPerView: 4,
        speed: 1200,
        breakpoints: {
          525: {
            slidesPerView: 2,
          },

          700: {
            slidesPerView: 3,
          },
        },
        on: {},
      },

      previewSwiperOptions: {
        // 邏輯 : preview-swiper 只靠 title-swiper 控制捲動，不需要自己動
        allowTouchMove: false,
        slidesPerView: 1,
        speed: 1200,
      },
    }
  },

  mounted() {
    this.currentItem = this.list[0]
  },

  methods: {
    // 邏輯 : 點擊 title-swiper 會讓 title-swiper、preview-swiper 都捲動
    // 寫在 methods 不寫在 titleSwiperOptions.on 是因為這樣交互比較滑順，原因不明
    slideTo(index) {
      this.currentIndex = index
      const titleSwiper = this.$refs['title-swiper'].swiper
      const previewSwiper = this.$refs['preview-swiper'].swiper
      titleSwiper.slideTo(index, 1200)
      previewSwiper.slideTo(index, 1200)
      this.currentItem = this.list[index]
    },

    slideNext() {
      this.slideTo((this.currentIndex + 1) % 4)
    },

    slidePrev() {
      this.slideTo((this.currentIndex - 1 + 4) % 4)
    },
  },
}
</script>

<style lang="scss" module>
$color-primary: #e3c192;

.sectionIncome {
  background-color: rgb(227, 193, 146, 0.04);

  :global {
    .wrapper-item-preview {
      display: flex;
      gap: 10px;
    }

    .title {
      font-size: 23px;
      margin-bottom: 24px;
      text-align: center;
      color: #1e1f21;
    }

    .description {
      font-size: 14px;
      margin-bottom: 0;
      line-height: 2;
      text-align: center;
    }

    .swiper-slide {
      text-align: center;
    }

    .income-wrapper {
      display: flex;
      flex-direction: column-reverse;

      .title-swiper {
        display: none;
      }

      .wrapper-item-title {
        .title {
          margin-top: 30px;
        }

        .left-arrow {
          padding: 8px;
          cursor: pointer;
          display: none;
        }

        .right-arrow {
          padding: 8px;
          cursor: pointer;
          display: none;
        }
      }
    }

    .title-swiper-item {
      text-align: center;
      cursor: pointer;

      .icon-img-wrapper {
        position: relative;
        transition: all 0.3;
        margin-bottom: 16px;

        &::before {
          content: '';
          top: 50%;
          left: 50%;
          position: absolute;
          background-color: #f4f4f4;
          width: 100px;
          height: 100px;
          border-radius: 50%;
          transform: translate(-50%, -50%);
          transition: all 0.3s;
        }

        .icon-img {
          position: relative;
          z-index: 2;
          padding: 24px;
          width: 100px;
          height: 100px;
        }

        .icon-bg {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 120px;
          opacity: 0;
          transition: all 0.3s;
        }
      }

      .icon-name {
        color: #959595;
        transition: all 0.3s;
        padding-top: 8px;
        margin-bottom: 40px;
      }
    }

    .isActive {
      .icon-img-wrapper {
        &::before {
          background-color: $color-primary;
        }

        .icon-img {
          filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
        }

        .icon-bg {
          opacity: 1;
        }
      }

      .icon-name {
        color: $color-primary;
      }
    }

    .preview-swiper-img {
      width: 100%;
      max-width: 500px;
    }
  }
}

@media (min-width: 992px) {
  .sectionIncome {
    :global {
      .wrapper-item-preview {
        .left-arrow {
          display: none;
        }
        .right-arrow {
          display: none;
        }
      }
      .title {
        margin-left: 16px;
        text-align: left;
      }

      .description {
        text-align: left;
        margin-left: 16px;
        margin-bottom: 30px;
      }

      .income-wrapper {
        padding: 0 100px;
        display: grid;
        grid-template-columns: 440px 1fr;

        .title-swiper {
          display: block;
        }

        .wrapper-item-title {
          margin-bottom: 40px;
          position: relative;
          order: 2;
          padding-left: 70px;
          align-self: center;

          .title {
            margin-top: 0;
          }

          .icon-name {
            margin-bottom: 0;
          }
          .left-arrow {
            display: block;
            position: absolute;
            left: 36px;
            bottom: 74px;
          }

          .right-arrow {
            display: block;
            position: absolute;
            right: -30px;
            bottom: 74px;
          }
        }

        .wrapper-item-preview {
          .preview-swiper-img {
            max-width: 100%;
          }
        }
      }
    }
  }
}
</style>
